<template>
  <b-field :label="label">
    <b-autocomplete
      :value="value"
      :data="dropdownElements"
      v-on:input="updateData"
      placeholder="Seleziona un elemento o descrivi"
      open-on-focus
      icon="caret-down"
      v-on:select="(option) => (selected = option)"
    ></b-autocomplete>
  </b-field>
</template>

<script>
const defaultDropdowValues = ["CORSIA", "TESTATA", "ISOLA"];

export default {
  name: "open-switch",
  props: ["value", "label", "options"],
  data() {
    return {
      dropdownElements: [],
    };
  },
  methods: {
    updateData(newVal) {
      this.$emit("input", newVal);
    },
  },
  mounted() {
    this.dropdownElements =
      this.options == null ? defaultDropdowValues : this.options;
  },
};
</script>